import React from "react";
import getConfig from "next/config";
import Link from "next/link";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const categories = [
  {
    img: "noutati",
    value: "noutati-5218/noutati",
  },
  {
    img: "oferte",
    value:
      "promotii-3803/promotii/in-stoc-5182/in-stoc/filtru-promotii/has-promotion",
  },
  {
    img: "articole-rare",
    value: "pentru-9396/adulti",
  },
];

const LegoPromoCategories = () => (
  <div className="flex">
    {categories.map(({ img, value }, index) => (
      <Link key={index} href={`/lego-jucarii/cpl/filtru/${value}`}>
        <a title="" className="lg:mx-12 text-center">
          <img
            src={`${settings.websiteStatics}/images/universul-lego/${img}.png`}
            alt=""
          />
        </a>
      </Link>
    ))}
  </div>
);

export default LegoPromoCategories;
